import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";

const BannerSettingGuard = ({ children }) => {
  const { user, isLoggedIn } = useAuth();

  if (isLoggedIn && user && user.canViewBannerSetting === false) {
    return <Navigate to="/dashboard/default" replace />;
  }

  return children;
};

BannerSettingGuard.propTypes = {
  children: PropTypes.node,
};

export default BannerSettingGuard;
